import { type EnvConfig } from '../types';

export const checkEnvironment = (): EnvConfig =>
  (window as { envConfig?: EnvConfig }).envConfig ?? {};

export const getLogoEndpointUrl = (logoName: string | undefined) => {
  if (!logoName) {
    return undefined;
  }

  const { IDWMS_API_URL } = checkEnvironment();

  if (IDWMS_API_URL) {
    return `${IDWMS_API_URL}/resource/image/app/${logoName}`;
  }

  return undefined;
};

const formatErrorString = (args: unknown[]): string => {
  if (args.length === 0) {
    return '';
  }

  const formatStr = args[0] as string;
  const tempArgs = args.slice(1);
  let formattedStr: string = formatStr;

  tempArgs.forEach((arg) => {
    formattedStr = formattedStr.replace('%s', arg as string);
  });

  return formattedStr;
};

export const suppressConsoleWarningsForTests = () => {
  // Store the original console.error
  // eslint-disable-next-line no-console -- to suppress console warning
  const originalConsoleError = console.error.bind(console);

  beforeAll(() => {
    // eslint-disable-next-line no-console -- to suppress console warning
    console.error = (...args: unknown[]) => {
      const errorMessage = formatErrorString(args);

      // Add all warning checks here
      const isDesiredError = Boolean(
        typeof errorMessage === 'string' &&
          (errorMessage.includes('validateDOMNesting') ||
            errorMessage.includes('Failed prop type'))
      );

      if (isDesiredError) {
        return;
      }

      originalConsoleError(...args);
    };
  });

  afterAll(() => {
    // eslint-disable-next-line no-console -- to suppress console warning
    console.error = originalConsoleError;
  });
};
